(function() {
    'use strict';

    angular
        .module('superChannelApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource', 'TenantService'];

    function PasswordResetFinish($resource, TenantService) {
        var service = $resource('api/account/reset_password/finish', {}, {
            'save': {
                method: 'POST',
                headers: { 'X-TenantID': TenantService.getFromUrl() }
            }
        });

        return service;
    }
})();
